export default __webpack_public_path__ + "static/media/about.0096696d.png";